<div
  class="order-item"
  [attr.data-cart-item-id]="cartItem().id"
  [class.order-item--selectable]="displaySelector()"
  [class.order-item--readonly]="readOnly()"
  [class.order-item--out-of-stock]="isOutOfStock()"
  [class.order-item--unavailable]="!isCategoryAvailable()"
  (click)="onItemClick()"
>
  @if (displaySelector()) {
    <div class="order-item__selector">
      <input
        type="checkbox"
        class="order-item__selector-input"
        [checked]="selected()"
        (click)="$event.stopPropagation()"
        (change)="onSelectorChange($event)"
      />
      <pxw-icon
        [hidden]="!selected()"
        class="order-item__selector-icon"
        icon="check"
        color="white"
      />
    </div>
  }

  <div class="order-item__rows">
    <ng-content select="pxw-cart-order-item-row" />
  </div>

  @if (hasOptions()) {
    <div class="order-item__options">
      <ng-content select="pxw-cart-order-item-option-group" />
    </div>
  } @else if (availableOptionsLabel()) {
    <div class="order-item__options order-item__options--hint">
      <pxw-icon icon="plus-sign" size="xs" />
      <span>{{ availableOptionsLabel() }}</span>
    </div>
  }

  @if (observations()) {
    <div class="order-item__observations">
      <pxw-icon icon="note" size="xs" />
      <span class="order-item__observations-text">"{{ observations() }}"</span>
    </div>
  }

  @if (!readOnly()) {
    <pxw-icon icon="chevron-right" size="xxs" class="tap-indicator" />
  }
</div>
